import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCcvY8UM9Ny7uAES4qZYqxTLvDtPrbjmao",
  authDomain: "housescan-c9b3b.firebaseapp.com",
  projectId: "housescan-c9b3b",
  storageBucket: "housescan-c9b3b.appspot.com",
  messagingSenderId: "660531248000",
  appId: "1:660531248000:web:4d29cc924a58207aec5f65",
  measurementId: "G-MS2CV634TC",
};

const app = initializeApp(firebaseConfig);

export { app };
